__turbopack_context__.v({
  "carouselColumn": "P2YLwa_carouselColumn",
  "chipButton": "P2YLwa_chipButton",
  "chipButtonSelected": "P2YLwa_chipButtonSelected",
  "chipItem": "P2YLwa_chipItem",
  "chips": "P2YLwa_chips",
  "dataColumn": "P2YLwa_dataColumn",
  "dataContent": "P2YLwa_dataContent",
  "emptyState": "P2YLwa_emptyState",
  "inner": "P2YLwa_inner",
  "kicker": "P2YLwa_kicker",
  "section": "P2YLwa_section",
  "title": "P2YLwa_title",
});
